module.exports = __webpack_public_path__ + "img/synthesis_popup_sold_out.2fe86ba9.png";